module.exports = __webpack_public_path__ + "static/media/13․062.0058cb64.jpg";